import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dropzone from "react-dropzone";
import styled, { css } from "styled-components";


import FileList from './FileList';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
    Grid,
    Button,
    colors
} from '@material-ui/core';


const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57878;
`;

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
  border: 2px dashed #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: height 0.2s ease;
  ${props => props.isDragActive && dragActive};
  ${props => props.isDragReject && dragReject};
`;

const messageColors = {
    default: "#00A0EF",
    error: "#e57878",
    success: "#78e5d5"
};

export const UploadMessage = styled.p`
  display: flex;
  color: ${props => messageColors[props.type || "default"]};
  justify-content: center;
  align-items: center;
  padding: 15px 0;
`;


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: colors.yellow[50],
        position: 'relative',
        overflow: 'auto'
    }
}));

const allowedMimes = [
    "video/mp4",
    "video/webm",
    "video/ogg",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
    "text/plain",
    "application/zip",
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow"
];

const Upload = ({ item, open, close, onUpload, uploadState, destinationTitle }) => {

    const classes = useStyles();

    const renderDragMessage = (isDragActive, isDragReject) => {
        if (!isDragActive) {
            return <UploadMessage>
                <Typography>
                    Arraste arquivos aqui...
                </Typography>
            </UploadMessage>;
        }

        if (isDragReject) {
            return <UploadMessage type="error">
                <Typography>
                    Arquivo não suportado...
                </Typography>
            </UploadMessage>;
        }

        return <UploadMessage type="success">
            <Typography>
                Solte os arquivos aqui..
            </Typography>
        </UploadMessage>;
    };

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md">
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        {(destinationTitle) ? destinationTitle : "Enviar Arquivos Para o Repositório"}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    {(uploadState.length == 0) ?

                        <Dropzone accept={allowedMimes} onDropAccepted={onUpload}   >
                            {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
                                <DropContainer className={classes.root}
                                    {...getRootProps()}
                                    isDragActive={isDragActive}
                                    isDragReject={isDragReject}
                                >
                                    <input {...getInputProps()} />
                                    {renderDragMessage(isDragActive, isDragReject)}
                                </DropContainer>
                            )}
                        </Dropzone>
                        : ("")
                    }
                    <br></br>
                    <FileList files={uploadState} />

                </DialogContent>

                <Divider />
                <DialogActions>
                    <Box my={1}></Box>
                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justify="flex-end"
                            alignItems="baseline"
                            spacing={1}  >
                            <Grid item >
                            </Grid>
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { close(item) }}>
                                    Fechar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogActions>
            </Dialog>

        </Fragment>
    );
};

export default Upload;
